export enum ActionTypes {
  REQUEST = "@calculo-avaliacoes/REQUEST",
  SUCCESS = "@calculo-avaliacoes/SUCCESS",
  FAILURE = "@calculo-avaliacoes/FAILURE",
}
